namespace $.$$ {
	$mol_style_define($bog_blitz_blog, {
	})
}
